(() => {
  const NAV_SELECTOR = '[data-gt-pill-nav]';
  const LIST_SELECTOR = '.gt-pill-list';
  const pendingMeasurements = new Map();
  let measurementFrame = 0;

  /*
   * ResizeObserver może uruchamiać się wiele razy podczas zmiany szerokości.
   * Najpierw mierzymy wszystkie rzędy, a dopiero potem aktualizujemy DOM.
   * Dzięki temu unikamy przeplatania odczytów i zapisów powodujących reflow.
   */
  const scheduleMeasurement = (rail, list) => {
    pendingMeasurements.set(rail, list);

    if (measurementFrame) return;

    measurementFrame = requestAnimationFrame(() => {
      measurementFrame = 0;

      const measurements = Array.from(pendingMeasurements, ([pendingRail, pendingList]) => {
        const maxScroll = Math.max(0, pendingList.scrollWidth - pendingList.clientWidth);

        return {
          rail: pendingRail,
          canScrollLeft: pendingList.scrollLeft > 2,
          canScrollRight: pendingList.scrollLeft < maxScroll - 2
        };
      });

      pendingMeasurements.clear();

      measurements.forEach(({ rail: pendingRail, canScrollLeft, canScrollRight }) => {
        const nextLeft = String(canScrollLeft);
        const nextRight = String(canScrollRight);

        if (pendingRail.dataset.canScrollLeft !== nextLeft) {
          pendingRail.dataset.canScrollLeft = nextLeft;
        }

        if (pendingRail.dataset.canScrollRight !== nextRight) {
          pendingRail.dataset.canScrollRight = nextRight;
        }
      });
    });
  };

  const arrowMarkup = (direction) => {
    const button = document.createElement('button');
    const isPrevious = direction === 'prev';

    button.className = `gt-pill-arrow gt-pill-arrow--${direction}`;
    button.type = 'button';
    button.setAttribute('aria-label', isPrevious ? 'Nach links scrollen' : 'Nach rechts scrollen');
    button.innerHTML = isPrevious
      ? '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    return button;
  };

  const markCurrentLink = (nav) => {
    const currentPath = window.location.pathname.replace(/\/$/, '');

    nav.querySelectorAll('.gt-pill[href]').forEach((link) => {
      let linkPath;

      try {
        linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (_error) {
        return;
      }

      if (linkPath === currentPath) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const enhanceList = (list) => {
    if (list.dataset.gtPillReady === 'true') return;
    list.dataset.gtPillReady = 'true';

    const rail = document.createElement('div');
    rail.className = 'gt-pill-rail';
    list.before(rail);
    rail.append(list);

    const previous = arrowMarkup('prev');
    const next = arrowMarkup('next');
    rail.prepend(previous);
    rail.append(next);

    const update = () => scheduleMeasurement(rail, list);

    const move = (direction) => {
      const distance = Math.max(220, list.clientWidth * .72);
      list.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    list.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(list);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    update();
  };

  const init = (scope = document) => {
    const navigations = [];

    if (scope.nodeType === 1 && scope.matches?.(NAV_SELECTOR)) {
      navigations.push(scope);
    }

    scope.querySelectorAll?.(NAV_SELECTOR).forEach((nav) => navigations.push(nav));

    navigations.forEach((nav) => {
      markCurrentLink(nav);
      nav.querySelectorAll(LIST_SELECTOR).forEach(enhanceList);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
